import { render } from "./RecoveryForm.vue?vue&type=template&id=bbc4e5ac"
import script from "./RecoveryForm.vue?vue&type=script&lang=js"
export * from "./RecoveryForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__